import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { SmsModel } from '../models/sms.model';
import { ServService } from './serv.service';
import { CustomerService } from './customer.service';
import { PostitService } from './postit.service';
import { Router } from '@angular/router';

@Injectable()
export class SmsService {

    public openPanel: boolean = false;
    public sms: SmsModel;
    public state: boolean = false;
    public isSend: boolean = false;

    /*private emitChangeSource = new Subject<any>();
     changeEmitted$ = this.emitChangeSource.asObservable();*/

    constructor(public apiService: ApiService, private servService: ServService, private customerService:CustomerService, private postitService:PostitService, private router:Router) {

    }

    open(clientPrivateId: string, mobile: string, name: string, from:string = null, id:string = null) {
        this.state = false;
        this.isSend = false;
        this.sms = new SmsModel(this);
        this.sms.clientPrivateId = clientPrivateId;
        this.sms.mobile = mobile;
        this.sms.name = name;
        this.sms.from = from;
        this.sms.id = id;
        this.openPanel = true;
        //this.emitChangeSource.next(open);
    }

    send(sms: SmsModel) {
        this.state = true;
        if (this.sms.validate()) {
            let data = {
                clientPrivateId: sms.clientPrivateId,
                mobile: sms.mobile.replace(/ /g, ''),
                message: sms.message,
            };

            if (data.mobile.length == 10 && data.mobile.substr(0, 1) == '0') {
                data.mobile = '0041' + data.mobile.substr(1, 9);
            }

            if (sms.from && sms.id){
                data['from'] = {'where': sms.from, 'id': sms.id};
            }

            this.apiService.post('sms', data).subscribe((_res)=> {
                this.isSend = true;
                this.state = false;
                setTimeout(() => {
                    this.openPanel = false;
                }, 1000);

                //notifie le service
                if (sms.from == 'service'){
                    this.servService.listOver.forEach((e) => {
                        if (e.privateId == sms.id){
                            e.whenContacted = true;
                        }
                    });
                }

                //notifie les postit
                if (sms.from == 'postit'){
                    this.postitService.isOpen = false;
                    if (this.router.url == '/postit/archive')
                        this.postitService.loadAll(true);
                    else
                        this.postitService.loadAll(false);
                }

                if (this.customerService.activities.privateId == sms.clientPrivateId) {
                    let newData = {
                        _id: '',
                        clientPrivateId: sms.clientPrivateId,
                        created: new Date().toDateString(),
                        message: sms.message,
                        mobile: sms.mobile,
                        state: '',
                        type: 'Sms',
                        from: {
                            where: 'nowhere'
                        }
                    };

                    if (sms.from){
                        newData.from.where = sms.from;
                    }

                    this.customerService.activities.data.unshift(newData);
                }
            }, (_err)=> {
                this.apiService.error(_err);
                this.state = false;
                if (sms.from == 'postit'){
                    this.postitService.isOpen = false;
                    if (this.router.url == '/postit/archive')
                        this.postitService.loadAll(true);
                    else
                        this.postitService.loadAll(false);
                }
            });
        } else {
            this.state = false;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/sms.service.ts